import React from "react";
import styled from "styled-components";
import ContatoZap from "../components/ContatoZap";
import ViewFooter from "../views/ViewFooter";
import ViewAppBar from "../views/ViewAppBar";
import ViewCadastroPropriedadeV2 from "../views/cadastroPropriedadeV2/ViewCadastroPropriedadeV2";

const ContainerComponente = styled.div`
  display: grid;

  @media (min-width: 200px) and (max-width: 299px) {
    grid-template-rows: 140px 1fr auto;
  }
  @media (min-width: 300px) and (max-width: 399px) {
    grid-template-rows: 140px 1fr auto;
  }
  @media (min-width: 400px) and (max-width: 499px) {
    grid-template-rows: 140px 1fr auto;
  }
  @media (min-width: 500px) {
    grid-template-rows: 130px 1fr auto;
  }
  @media (min-width: 1100px) {
    grid-template-rows: 100px 1fr auto;
  }
`;

const CadastroPropriedadeV2: React.FC = () => (
  <ContainerComponente>
    <ContatoZap />
    <ViewAppBar />
    <ViewCadastroPropriedadeV2 />
    <ViewFooter />
  </ContainerComponente>
);

export default CadastroPropriedadeV2;
